import { render, staticRenderFns } from "./CoreMainMenu.vue?vue&type=template&id=4d00ee11&scoped=true"
import script from "./CoreMainMenu.vue?vue&type=script&lang=js"
export * from "./CoreMainMenu.vue?vue&type=script&lang=js"
import style0 from "./CoreMainMenu.vue?vue&type=style&index=0&id=4d00ee11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d00ee11",
  null
  
)

export default component.exports